import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Order,LoginInfo } from '../model/types';
import { Http, Headers, RequestOptions,Response } from '@angular/http';
import { Storage } from '@ionic/storage';

//page
import { OrderdetailsPage } from '../orderdetails/orderdetails';
import { MenuPage } from '../menu/menu'
import { LoginPage } from '../login/login'

//service
import { AppSharedService  } from '../service/app_shared';

@Component({
  selector: 'page-order',
  templateUrl: 'order.html',
})
export class OrderPage {

  //class level variable
  orderList:Order[];
  imageUrlResources  : string;

  //constructor
  constructor(public navCtrl: NavController
              ,public navParams: NavParams
              ,private http: Http
              ,private storage: Storage
              ,public appSharedService:AppSharedService
              ,public loadingCtrl : LoadingController
            ) {
         
          // initialize class variable
          this.orderList=[];
          this.imageUrlResources= this.appSharedService.configInfo.applicationInfo.fileBasePath+'/Images/AppResources/';
  }
  ionViewDidEnter(){
    this.getOrderDetails();
  }
  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }
  
  // go to order details page
  showDetails(orderObj:Order){
     this.navCtrl.push(OrderdetailsPage,{orderId:orderObj.OrderId});
  }

  //get order list
  getOrderDetails(){
    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
      
      //create loader
      let loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });

      // create header
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});
      
      //create url
      var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlGetOrderHistory);
     
    //display loader
    loading.present();

    // do the service call
     this.http.get(url,options )
         .subscribe((res: Response) => {   
              
          if(res.status==200){
                this.orderList= JSON.parse(res.text()) as Order[];
                loading.dismiss();
          }
          else if(res.status==204){       
                loading.dismiss();
                this.storage.clear();
                this.navCtrl.popToRoot();
                this.navCtrl.setRoot(LoginPage)
          }
              else{
                loading.dismiss();
              }
           });
          }
       });     
    }
}



// WEBPACK FOOTER //
// ./src/pages/order/order.ts